module.exports = __webpack_public_path__ + "static/media/The_Mix3.e5f717f8.png";